module.exports = __webpack_public_path__ + "img/f6b14ec.svg";